(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5316],{

/***/ 38472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
function n(){return(n=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}).apply(this,arguments)}function r(r){var o,l=r.current,a=r.next,i=r.className,c=r.style,s=react__WEBPACK_IMPORTED_MODULE_0__.useState({current:l,next:a}),u=s[0],d=s[1],f=react__WEBPACK_IMPORTED_MODULE_0__.useState(!1),v=f[0],m=f[1];return react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function(){u.current!==l?(u.current===u.next&&d(n({},u,{next:a})),m(!0)):m(!1)},[l,a]),react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:(0,clsx__WEBPACK_IMPORTED_MODULE_1__["default"])("_2EBbg",i),style:c},react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:"_SKh-V"},u.next),react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:"_106d2"},u.current),react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:(0,clsx__WEBPACK_IMPORTED_MODULE_1__["default"])("_3luxx",(o={},o._2kgZC=v,o)),onTransitionEnd:function(){d({current:l,next:a}),m(!1)}},react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:(0,clsx__WEBPACK_IMPORTED_MODULE_1__["default"])("_2v-d4","_1GZQ7")},u.current),react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:(0,clsx__WEBPACK_IMPORTED_MODULE_1__["default"])("_2v-d4","_3AVXa")},u.next)))}function o(e){var t=new Date(e);if(isNaN(t.getTime()))throw Error("Invalid date");var n=new Date,r=Math.round((t.getTime()-n.getTime())/1e3);return r<0&&(r=0),{total:r,days:Math.floor(r/86400),hours:Math.floor(r/3600%24),minutes:Math.floor(r/60%60),seconds:Math.floor(r%60)}}function l(e){return("0".repeat(Math.max(0,2-String(e).length))+String(e)).split("")}function a(e){if(void 0!==e)return"string"==typeof e?e:e+"px"}var i=["to","className","style","children","onComplete","onTick","showLabels","showSeparators","labels","labelStyle","digitBlockStyle","separatorStyle","dividerStyle","duration","renderMap"];function c(c){var s,u=c.to,d=c.className,f=c.style,v=c.children,m=c.onComplete,h=c.onTick,g=c.showLabels,p=c.showSeparators,b=c.labels,y=c.labelStyle,S=c.digitBlockStyle,x=c.separatorStyle,w=c.dividerStyle,E=c.duration,k=c.renderMap,N=function(e,t){if(null==e)return{};var n,r,o={},l=Object.keys(e);for(r=0;r<l.length;r++)t.indexOf(n=l[r])>=0||(o[n]=e[n]);return o}(c,i),M=react__WEBPACK_IMPORTED_MODULE_0__.useState(),_=M[0],O=M[1],T=react__WEBPACK_IMPORTED_MODULE_0__.useRef(0);function z(){window.clearInterval(T.current)}function D(){var e=o(u);return{timeDelta:e,completed:0===e.total}}function j(){var e=D();O(e),h(e),e.completed&&(z(),m())}react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function(){return O(D()),z(),T.current=window.setInterval(j,1e3),function(){return z()}},[u]);var C=react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function(){return n({"--fcc-flip-duration":void 0===E||E<0||E>1?void 0:E+"s","--fcc-digit-block-width":a(null==S?void 0:S.width),"--fcc-digit-block-height":a(null==S?void 0:S.height),"--fcc-shadow":null==S?void 0:S.boxShadow,"--fcc-digit-font-size":a(null==S?void 0:S.fontSize),"--fcc-digit-color":null==S?void 0:S.color,"--fcc-label-font-size":a(null==y?void 0:y.fontSize),"--fcc-label-color":null==y?void 0:y.color,"--fcc-divider-color":null==w?void 0:w.color,"--fcc-divider-height":a(null==w?void 0:w.height),"--fcc-background":(null==S?void 0:S.background)||(null==S?void 0:S.backgroundColor),"--fcc-separator-size":a(null==x?void 0:x.size),"--fcc-separator-color":p?null==x?void 0:x.color:"transparent"},f)},[f,S,y,E,w,x,p]),B=react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function(){if(S)return n({},S,{background:void 0,backgroundColor:void 0,width:void 0,height:void 0,boxShadow:void 0,fontSize:void 0,color:void 0})},[S]),F=react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function(){if(void 0!==_){var e,t,n=(e=_.timeDelta,t=o((new Date).getTime()+1e3*(e.total-1)),{days:{current:l(e.days),next:l(t.days)},hours:{current:l(e.hours),next:l(t.hours)},minutes:{current:l(e.minutes),next:l(t.minutes)},seconds:{current:l(e.seconds),next:l(t.seconds)}}),r=k.length>=4?k.slice(0,4):[!0,!0,!0,!0],a=b.length>=4?b.slice(0,4):["Days","Hours","Minutes","Seconds"],i=Object.values(n),c=[];return r.forEach(function(e,t){e&&c.push([i[t],a[t]])}),c}},[k,_]);return void 0===_||void 0===F?react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null):null!=_&&_.completed?react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,v):react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",Object.assign({},N,{className:(0,clsx__WEBPACK_IMPORTED_MODULE_1__["default"])("_qWTcH",(s={},s._1tbqx=g,s),d),style:C,"data-testid":"fcc-container"}),F.map(function(e,n){var o=e[0];return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,{key:"digit-block-"+n},react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:"_3cpN7"},g&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:"_2aOn7",style:y},e[1]),o.current.map(function(e,n){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(r,{key:n,current:e,next:o.next[n],style:B})})),n<F.length-1&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:"_2hRXr"}))}))}c.defaultProps={onComplete:function(){},onTick:function(){},labels:["Days","Hours","Minutes","Seconds"],renderMap:[!0,!0,!0,!0],showLabels:!0,showSeparators:!0};/* harmony default export */ __webpack_exports__["Z"] = (c);
//# sourceMappingURL=index.modern.js.map


/***/ }),

/***/ 54167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_common_Nav__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27356);
/* harmony import */ var react_div_100vh__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66409);







var Container = function(_param) {
    var children = _param.children, id = _param.id, showConnect = _param.showConnect, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children",
        "id",
        "showConnect"
    ]);
    var height = (0,react_div_100vh__WEBPACK_IMPORTED_MODULE_3__/* .use100vh */ .g)();
    var connectShow = typeof showConnect === "undefined" ? true : showConnect;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props), {
        className: "layout-content",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_Nav__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                showConnect: connectShow
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    height: height ? "".concat(height - 60, "px") : "calc(100vh-60px)"
                },
                id: id,
                className: "overflow-y-scroll overflow-x-hidden",
                children: children
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Container);


/***/ }),

/***/ 49328:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _form_components_common_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85119);
/* harmony import */ var _hooks_useAccount__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98786);
/* harmony import */ var _utils_format__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6767);
/* harmony import */ var _hooks_useVerifyClaim__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37091);
/* harmony import */ var _hooks_useToggleStatus__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45576);
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69077);
/* harmony import */ var _chain_info_KaratDaoSupportedChain__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93171);









var ConnectWalletStep = function(param) {
    var chainId = param.chainId;
    var ref;
    var ref1 = (0,_hooks_useAccount__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(), login = ref1.login, isLogin = ref1.isLogin, address = ref1.address, logout = ref1.logout;
    var changeVerifyState = (0,_hooks_useVerifyClaim__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("account").changeVerifyState;
    var open = (0,_hooks_useToggleStatus__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("claimerMintToggleStatus").open;
    var mintChain = _chain_info_KaratDaoSupportedChain__WEBPACK_IMPORTED_MODULE_7__/* .KARATDAO_DEFAULT_SUPPORTED_CHAINS.find */ .f.find(function(item) {
        return item.chainId === chainId;
    });
    var ref2 = (0,wagmi__WEBPACK_IMPORTED_MODULE_8__/* .useBalance */ .KQ)({
        address: address,
        chainId: chainId,
        watch: false
    }), balance = ref2.data, refetch = ref2.refetch;
    var ref3 = (0,wagmi__WEBPACK_IMPORTED_MODULE_8__/* .useBalance */ .KQ)({
        address: address,
        chainId: 1,
        watch: false
    }), ethBalance = ref3.data;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        changeVerifyState(isLogin);
        isLogin && open("accounts");
    }, [
        isLogin
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "claim-step-card",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_form_components_common_icons__WEBPACK_IMPORTED_MODULE_2__/* .CheckIcon */ .nQ, {
                        className: "w-5 h-5 ".concat(isLogin ? "fill-green" : "")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "font-semibold text-dark1 ml-2",
                        children: "Connect wallet"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex-1"
                    }),
                    isLogin ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-sm text-gray1 mr-1",
                                children: (0,_utils_format__WEBPACK_IMPORTED_MODULE_4__/* .trimAddr1 */ .Cr)(address || "", 5)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "action ml-1 w-[14px] h-[14px] rounded-full bg-primary flex items-center justify-center",
                                onClick: logout,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_form_components_common_icons__WEBPACK_IMPORTED_MODULE_2__/* .CloseIcon */ .Tw, {
                                    className: "w-[6px]"
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "action text-primary font-semibold",
                        onClick: login,
                        children: address ? "Sign Message" : "Connect"
                    })
                ]
            }),
            address && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "border-t border-t-[#E0E1E1] mt-4 pt-4 flex flex-wrap gap-5 sm:gap-10",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "text-sm",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-gary2 font-semibold",
                                children: "Wallet address"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-gray1 mt-1",
                                children: (0,_utils_format__WEBPACK_IMPORTED_MODULE_4__/* .trimAddr1 */ .Cr)(address, 8)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "text-sm",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "text-gary2 font-semibold",
                                children: [
                                    mintChain.chainName,
                                    " balance"
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "text-gray1 mt-1",
                                children: [
                                    parseFloat((balance === null || balance === void 0 ? void 0 : balance.formatted) || "0").toFixed(3),
                                    (ref = mintChain.nativeCurrency) === null || ref === void 0 ? void 0 : ref.symbol
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "text-sm",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-gary2 font-semibold",
                                children: "Ethereum balance"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "text-gray1 mt-1",
                                children: [
                                    parseFloat((ethBalance === null || ethBalance === void 0 ? void 0 : ethBalance.formatted) || "0").toFixed(3),
                                    "ETH"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ConnectWalletStep);


/***/ }),

/***/ 18359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ mint_VerifyAccountsStep; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/form/components/common/icons.tsx
var icons = __webpack_require__(85119);
// EXTERNAL MODULE: ./src/hooks/useAccount.tsx
var useAccount = __webpack_require__(98786);
// EXTERNAL MODULE: ./src/hooks/useVerifyClaim.ts
var useVerifyClaim = __webpack_require__(37091);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Collapse/Collapse.js + 1 modules
var Collapse = __webpack_require__(31003);
// EXTERNAL MODULE: ./src/components/common/icons.tsx
var common_icons = __webpack_require__(58163);
// EXTERNAL MODULE: ./src/form/hooks/useUserTwitter.tsx + 1 modules
var useUserTwitter = __webpack_require__(53969);
// EXTERNAL MODULE: ./src/form/services/modal.tsx
var modal = __webpack_require__(33799);
;// CONCATENATED MODULE: ./src/components/mint/TwitterVerify.tsx








var TwitterVerify = function() {
    var ref = (0,useAccount/* default */.Z)(), isLogin = ref.isLogin, login = ref.login;
    var ref1 = (0,useVerifyClaim/* default */.Z)("account_twitter"), result = ref1.result, changeVerifyState = ref1.changeVerifyState;
    var verifyed = result["account_twitter"];
    var ref2 = (0,useUserTwitter/* default */.Z)(), twitter = ref2.twitter, connect = ref2.connect, connecting = ref2.connecting, authLink = ref2.authLink, disconnect = ref2.disconnect;
    var isConnected = !!twitter && isLogin;
    (0,react.useEffect)(function() {
        changeVerifyState(isConnected);
    }, [
        isConnected
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center bg-white/70 rounded-lg py-4 px-7 select-none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckIcon */.nQ, {
                className: "w-5 h-5 ".concat(verifyed ? "fill-green" : "")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* TwitterIcon */.Zm, {
                className: "fill-twitter ml-2 w-5 h-5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-sm font-semibold text-dark1 ml-1",
                children: "Twitter"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex-1"
            }),
            isConnected ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "text-gray1 text-sm select-text",
                        children: [
                            "@",
                            twitter === null || twitter === void 0 ? void 0 : twitter.username
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "action ml-1 w-[14px] h-[14px] rounded-full bg-primary flex items-center justify-center",
                        onClick: function() {
                            (0,modal/* confirm */.i)({
                                title: "Are you sure to disconnect your account?",
                                okText: "Disconnect",
                                okType: "danger",
                                onOk: function onOk() {
                                    disconnect();
                                }
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CloseIcon */.Tw, {
                            className: "w-[6px]"
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                rel: "noreferrer",
                href: authLink,
                className: "font-semibold text-sm text-primary hover:text-primary",
                target: "_blank",
                onClick: function(e) {
                    if (!isLogin) {
                        login();
                        e.preventDefault();
                        return false;
                    }
                    if (!authLink) {
                        e.preventDefault();
                        return false;
                    }
                    connect();
                },
                children: "Connect"
            })
        ]
    });
};
/* harmony default export */ var mint_TwitterVerify = (TwitterVerify);

// EXTERNAL MODULE: ./src/form/hooks/useUserDiscord.ts + 1 modules
var useUserDiscord = __webpack_require__(78867);
;// CONCATENATED MODULE: ./src/components/mint/DiscordVerify.tsx








var DiscordVerify = function() {
    var ref = (0,useAccount/* default */.Z)(), isLogin = ref.isLogin, login = ref.login;
    var ref1 = (0,useVerifyClaim/* default */.Z)("account_discord"), result = ref1.result, changeVerifyState = ref1.changeVerifyState;
    var verifyed = result["account_discord"];
    var ref2 = (0,useUserDiscord/* default */.Z)(), discord = ref2.discord, connect = ref2.connect, connecting = ref2.connecting, authLink = ref2.authLink, disconnect = ref2.disconnect;
    var isConnected = !!discord && isLogin;
    (0,react.useEffect)(function() {
        changeVerifyState(isConnected);
    }, [
        isConnected
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center bg-white/70 rounded-lg py-4 px-7 select-none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckIcon */.nQ, {
                className: "w-5 h-5 ".concat(verifyed ? "fill-green" : "")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DiscordIcon */.D7, {
                className: "fill-discord ml-2 w-5 h-5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-sm font-semibold text-dark1 ml-1",
                children: "Discord"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex-1"
            }),
            isConnected ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "text-gray1 text-sm select-text",
                        children: [
                            "@",
                            (discord === null || discord === void 0 ? void 0 : discord.global_name) || (discord === null || discord === void 0 ? void 0 : discord.username)
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "action ml-1 w-[14px] h-[14px] rounded-full bg-primary flex items-center justify-center",
                        onClick: function() {
                            (0,modal/* confirm */.i)({
                                title: "Are you sure to disconnect your account?",
                                okText: "Disconnect",
                                okType: "danger",
                                onOk: function onOk() {
                                    disconnect();
                                }
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CloseIcon */.Tw, {
                            className: "w-[6px]"
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                rel: "noreferrer",
                href: authLink,
                className: "font-semibold text-sm text-primary hover:text-primary",
                target: "_blank",
                onClick: function(e) {
                    if (!isLogin) {
                        login();
                        e.preventDefault();
                        return false;
                    }
                    if (!authLink) {
                        e.preventDefault();
                        return false;
                    }
                    connect();
                },
                children: "Connect"
            })
        ]
    });
};
/* harmony default export */ var mint_DiscordVerify = (DiscordVerify);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./src/form/hooks/useUserEmail.tsx
var useUserEmail = __webpack_require__(80541);
// EXTERNAL MODULE: ./src/form/utils/validate.ts
var validate = __webpack_require__(65746);
// EXTERNAL MODULE: ./src/stores/index.ts + 23 modules
var stores = __webpack_require__(27234);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Loader/Loader.js + 3 modules
var Loader = __webpack_require__(76080);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/TextInput/TextInput.js
var TextInput = __webpack_require__(80061);
// EXTERNAL MODULE: ./src/form/services/account.ts
var account = __webpack_require__(86748);
;// CONCATENATED MODULE: ./src/components/mint/EmailVerify.tsx














var EmailVerify = function() {
    var ref = (0,useAccount/* default */.Z)(), isLogin = ref.isLogin, login = ref.login;
    var ref1 = (0,useVerifyClaim/* default */.Z)("account_email"), result = ref1.result, changeVerifyState = ref1.changeVerifyState;
    var userInfo = (0,stores/* useTypedSelector */.ix)(function(state) {
        return state.account.userInfo;
    });
    var verifyed = result["account_email"] && isLogin;
    var ref2 = (0,useUserEmail/* default */.Z)(true), email = ref2.email, setEmail = ref2.setEmail, verify = ref2.verify, verifying = ref2.verifying;
    var isEmailValid = (0,validate/* validateEmail */.oH)(email);
    (0,react.useEffect)(function() {
        changeVerifyState(!!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.email));
    }, [
        userInfo === null || userInfo === void 0 ? void 0 : userInfo.email
    ]);
    var sendEmail = (0,react.useCallback)(function() {
        if (!isEmailValid) {
            return;
        }
        if (!isLogin) {
            return login();
        }
        verify();
    }, [
        isLogin,
        verify,
        isEmailValid
    ]);
    var disconnect = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,account/* revokeEmail */.px)()
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), []);
    var rightSection = null;
    if (!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.email)) {
        if (verifying) {
            rightSection = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-end w-full pr-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {
                    size: "xs"
                })
            });
        } else {
            rightSection = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-body font-bold text-primary action translate-x-8 ".concat(isEmailValid ? "" : "opacity-50 hover:cursor-not-allowed"),
                onClick: sendEmail,
                children: "bind"
            });
        }
    } else {
        rightSection = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "action translate-x-10 ml-1 w-[14px] h-[14px] rounded-full bg-primary flex items-center justify-center",
            onClick: function() {
                (0,modal/* confirm */.i)({
                    title: "Are you sure to disconnect your account?",
                    okText: "Disconnect",
                    okType: "danger",
                    onOk: function onOk() {
                        disconnect();
                    }
                });
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CloseIcon */.Tw, {
                className: "w-[6px]"
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: " bg-white/70 rounded-lg py-4 px-7 select-none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckIcon */.nQ, {
                        className: "w-5 h-5 ".concat(verifyed ? "fill-green" : "")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EmailIcon */.LQ, {
                        className: "fill-dark1 ml-2 w-5 h-5 mr-[1px]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-sm font-semibold text-dark1 ml-1",
                        children: "Email"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                readOnly: !!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.email) || verifying,
                value: email,
                className: "mt-2 ml-7",
                size: "md",
                classNames: {
                    input: "border-[#e7e7e7] pl-4  rounded-lg",
                    rightSection: ""
                },
                placeholder: "Your email",
                rightSectionWidth: 130,
                rightSection: rightSection,
                onChange: function(e) {
                    setEmail(e.currentTarget.value);
                }
            })
        ]
    });
};
/* harmony default export */ var mint_EmailVerify = (EmailVerify);

// EXTERNAL MODULE: ./src/hooks/useToggleStatus.ts + 1 modules
var useToggleStatus = __webpack_require__(45576);
// EXTERNAL MODULE: ./src/hooks/useMintReferral.ts
var useMintReferral = __webpack_require__(65581);
// EXTERNAL MODULE: ./src/hooks/useMintType.ts
var useMintType = __webpack_require__(70850);
;// CONCATENATED MODULE: ./src/components/mint/VerifyAccountsStep.tsx














var VerifyAccountsStep = function(param) {
    var chainId = param.chainId;
    var isLogin = (0,useAccount/* default */.Z)().isLogin;
    var result = (0,useVerifyClaim/* default */.Z)().result;
    var ref = (0,useToggleStatus/* default */.Z)("claimerMintToggleStatus"), claimerMintToggleStatus = ref.claimerMintToggleStatus, toggle = ref.toggle;
    var mintReferral = (0,useMintReferral/* default */.Z)(chainId);
    var mintType = (0,useMintType/* default */.Z)();
    var isSimpleMode = mintReferral.isOKX && mintType === "claimer";
    var opened = claimerMintToggleStatus.accounts;
    var toggleCard = (0,react.useCallback)(function() {
        toggle("accounts");
    }, [
        toggle
    ]);
    var verifyed = isSimpleMode ? result["account_email"] : result["account_twitter"] && result["account_discord"] && result["account_email"];
    (0,react.useEffect)(function() {
        if (isLogin) {
            var timer = setInterval(function() {
                stores/* default.dispatch */.ZP.dispatch(stores/* actions.account.fetchUserInfo */.Nw.account.fetchUserInfo());
            }, 3000);
            return function() {
                clearInterval(timer);
            };
        }
    }, [
        isLogin
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "claim-step-card  ".concat(opened ? "border-primary bg-[rgba(235,243,255,0.3)]" : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex cursor-pointer",
                onClick: toggleCard,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckIcon */.nQ, {
                        className: "w-5 h-5 ".concat(verifyed ? "fill-green" : "")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "font-semibold text-dark1 ml-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: "Verify accounts"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-gray1 font-normal text-sm mt-1 ".concat(opened ? "block" : "hidden"),
                                children: "Verify your socials accounts and email"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_icons/* ArrowDownIcon */.ve, {
                        className: "transition-all self-center ".concat(opened ? "rotate-180" : "")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* Collapse */.U, {
                in: opened,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-4 gap-2 flex flex-col cursor-auto",
                    onClick: function(e) {
                        e.stopPropagation();
                    },
                    children: [
                        !isSimpleMode && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(mint_TwitterVerify, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(mint_DiscordVerify, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(mint_EmailVerify, {})
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var mint_VerifyAccountsStep = (VerifyAccountsStep);


/***/ }),

/***/ 28518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_T": function() { return /* binding */ TDK; },
/* harmony export */   "lU": function() { return /* binding */ serve_address; }
/* harmony export */ });
/* unused harmony export walletconnect_project_id */
var serve_address =  true ? "https://api.karatdao.com/action" : 0;
var walletconnect_project_id = "031d2b33f0e66c821d14c5bbaaa6b611";
var TDK = {
    title: "KaratForm: NFT Allowlist Collection Tool",
    description: "Easiest way to onboard web3 users with twitter, discord, and telegram. Launch a KaratForm to track and gain insights about your community under just one minute!",
    keywords: "KaratForm,Words: Premint Alternative,NFT allowlist,NFT allowlist,Wallet Collector,Address Collector,Wallet Management",
    cover: "https://s2.loli.net/2022/10/09/y4OKohqxgjZpT3W.jpg"
};


/***/ }),

/***/ 7395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70655);
/* harmony import */ var umi_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11238);
/* harmony import */ var _stores__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27234);
/* harmony import */ var _config_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28518);
/* harmony import */ var _config_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35055);
/**
 * request 网络请求工具
 * 更详细的 api 文档: https://github.com/umijs/umi-request
 */ 





var codeMessage = {
    200: "服务器成功返回请求的数据。",
    201: "新建或修改数据成功。",
    202: "一个请求已经进入后台排队（异步任务）。",
    204: "删除数据成功。",
    400: "发出的请求有错误，服务器没有进行新建或修改数据的操作。",
    401: "用户没有权限（令牌、用户名、密码错误）。",
    403: "用户得到授权，但是访问是被禁止的。",
    404: "发出的请求针对的是不存在的记录，服务器没有进行操作。",
    406: "请求的格式不可得。",
    410: "请求的资源被永久删除，且不会再得到的。",
    422: "当创建一个对象时，发生一个验证错误。",
    500: "服务器发生错误，请检查服务器。",
    502: "网关错误。",
    503: "服务不可用，服务器暂时过载或维护。",
    504: "网关超时。"
};
/**
 * 异常处理程序
 */ var errorHandler = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(error) {
        var response, errorText;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    response = error.response;
                    if (!(response && response.status)) return [
                        3,
                        2
                    ];
                    errorText = codeMessage[response.status] || response.statusText;
                    if (!!errorText) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        response.text()
                    ];
                case 1:
                    errorText = _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2,
                        response
                    ];
            }
        });
    });
    return function errorHandler(error) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * 配置request请求时的默认参数
 */ var request = (0,umi_request__WEBPACK_IMPORTED_MODULE_0__/* .extend */ .l7)({
    errorHandler: errorHandler,
    // 默认错误处理
    credentials: "include",
    timeout: 10000
});
request.rpc = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(method) {
        var params, headers, myHeaders, session, raw, requestOptions, response, err, resp;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : [], headers = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {};
                    if (_config_config__WEBPACK_IMPORTED_MODULE_3__/* .isMaintenance */ .b6) {
                        throw new Error(_config_config__WEBPACK_IMPORTED_MODULE_3__/* .maintenanceApiMessage */ .Bn);
                    }
                    myHeaders = new Headers();
                    myHeaders.append("Content-Type", "application/json");
                    myHeaders.append("ref",  true ? window.location.href : 0);
                    session = _stores__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getState */ .ZP.getState().account.session;
                    if (session) {
                        myHeaders.append("token", session.token);
                    }
                    Object.keys(headers).forEach(function(key) {
                        myHeaders.append(key, headers[key]);
                    });
                    raw = JSON.stringify({
                        method: method,
                        params: params
                    });
                    requestOptions = {
                        method: "POST",
                        headers: myHeaders,
                        body: raw,
                        redirect: "follow"
                    };
                    response = null;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        fetch( true ? _config_config__WEBPACK_IMPORTED_MODULE_2__/* .serve_address */ .lU : 0, requestOptions)
                    ];
                case 2:
                    response = _state.sent();
                    // console.log(response);
                    if (response.status !== 200) {
                        errorHandler({
                            response: response
                        });
                        return [
                            2,
                            null
                        ];
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    err = _state.sent();
                    throw err;
                case 4:
                    return [
                        4,
                        response.json()
                    ];
                case 5:
                    resp = _state.sent();
                    if ("error" in resp) {
                        if (resp.error.message === "Token is not valid. Please login again") {
                            _stores__WEBPACK_IMPORTED_MODULE_1__/* ["default"].dispatch */ .ZP.dispatch(_stores__WEBPACK_IMPORTED_MODULE_1__/* .actions.account.removeSession */ .Nw.account.removeSession());
                        }
                        throw resp.error;
                    } else if ("result" in resp) {
                        return [
                            2,
                            resp.result
                        ];
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return function(method) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = (request);


/***/ }),

/***/ 65746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "At": function() { return /* binding */ isValidAddress; },
/* harmony export */   "HG": function() { return /* binding */ validateDiscordChannelLink; },
/* harmony export */   "JO": function() { return /* binding */ validateTwitterLink; },
/* harmony export */   "Zh": function() { return /* binding */ validateDiscordServerLink; },
/* harmony export */   "oH": function() { return /* binding */ validateEmail; },
/* harmony export */   "s_": function() { return /* binding */ validateSendingMeSquadLink; }
/* harmony export */ });
/* unused harmony export validateTelegramGroupLink */
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7258);

var validateEmail = function(email) {
    if (!email) {
        return false;
    }
    return yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().email().isValidSync(email);
};
var RTwitterLink = /^https:\/\/twitter.com\/[^/]+\/status\/\d+/;
var validateTwitterLink = function(url) {
    if (!url) {
        return false;
    }
    return RTwitterLink.test(url);
};
var validateDiscordServerLink = function(url) {
    if (!url) {
        return false;
    }
    return url.indexOf("https://discord.gg/") === 0 || url.indexOf("https://discord.com/invite") === 0;
};
var validateSendingMeSquadLink = function(url) {
    if (!url) {
        return false;
    }
    return url.indexOf("sending.me/share/?squad=") > 0;
};
var validateDiscordChannelLink = function(url) {
    if (!url) {
        return false;
    }
    return url.indexOf("https://discord.com/channels") === 0;
};
var RTelegramGroupLink = /^https:\/\/t.me\/./;
var validateTelegramGroupLink = function(url) {
    if (!url) {
        return false;
    }
    return RTelegramGroupLink.test(url);
};
var REGEX_ADDRESS = /^0x[A-F0-9]{40}$/i;
var isValidAddress = function(address) {
    return REGEX_ADDRESS.test(address);
};


/***/ }),

/***/ 45497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useBridge; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(70655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69077);
/* harmony import */ var _hooks_useVerifyClaim__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37091);
/* harmony import */ var zksync_web3__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31041);
/* harmony import */ var zksync_web3__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(zksync_web3__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _chain_info_contracts_Escrow_json__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95902);
/* harmony import */ var ethers__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(61744);
/* harmony import */ var _stores__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27234);
/* harmony import */ var _hooks_useMintHistory__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56146);
/* harmony import */ var _hooks_useMintType__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70850);
/* harmony import */ var _chain_info_contracts_MockERC20_json__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(77212);
/* harmony import */ var mixpanel_browser__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8891);
/* harmony import */ var mixpanel_browser__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(mixpanel_browser__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var wagmi_actions__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(17276);
/* harmony import */ var _services_ethers__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(10644);
/* harmony import */ var _utils_validate__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(68974);

















function isNativeToken(address) {
    return address === "0x0000000000000000000000000000000000000000" || address === "0x0000000000000000000000000000000000001010";
}
function useBridge(historyPrefix) {
    var ref, ref1, ref2, ref3;
    var ref4 = (0,_hooks_useVerifyClaim__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(), form = ref4.form, changeFormField = ref4.changeFormField;
    var ref5 = (0,_hooks_useMintHistory__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(), history = ref5.history, historyStatus = ref5.status;
    var mintType = (0,_hooks_useMintType__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    var connector = (0,wagmi__WEBPACK_IMPORTED_MODULE_10__/* .useAccount */ .mA)().connector;
    var chain = (0,wagmi__WEBPACK_IMPORTED_MODULE_10__/* .useNetwork */ .LN)().chain;
    var switchNetworkAsync = (0,wagmi__WEBPACK_IMPORTED_MODULE_10__/* .useSwitchNetwork */ .g0)().switchNetworkAsync;
    var ref6 = (0,_stores__WEBPACK_IMPORTED_MODULE_4__/* .useTypedSelector */ .ix)(function(state) {
        return state.bridge;
    }), depositing = ref6.depositing, depositSuccess = ref6.depositSuccess;
    var escrowDepositInfo = form === null || form === void 0 ? void 0 : form.karat;
    var ref7 = (0,wagmi__WEBPACK_IMPORTED_MODULE_10__/* .useContractWrite */ .GG)({
        address: escrowDepositInfo === null || escrowDepositInfo === void 0 ? void 0 : escrowDepositInfo.escrowContractAddress,
        abi: _chain_info_contracts_Escrow_json__WEBPACK_IMPORTED_MODULE_3__/* .abi */ .Mt,
        functionName: "depositNativeToken",
        chainId: escrowDepositInfo === null || escrowDepositInfo === void 0 ? void 0 : (ref = escrowDepositInfo.token) === null || ref === void 0 ? void 0 : ref.chainId,
        value: isNativeToken(escrowDepositInfo === null || escrowDepositInfo === void 0 ? void 0 : escrowDepositInfo.token.tokenAddress) ? ethers__WEBPACK_IMPORTED_MODULE_11__.parseEther(String((escrowDepositInfo === null || escrowDepositInfo === void 0 ? void 0 : (ref1 = escrowDepositInfo.tokenAmount) === null || ref1 === void 0 ? void 0 : ref1.toFixed(18)) || "0")).toBigInt() : 0n
    }), depositNativeToken = ref7.writeAsync;
    var ref8 = (0,wagmi__WEBPACK_IMPORTED_MODULE_10__/* .useContractWrite */ .GG)({
        address: escrowDepositInfo === null || escrowDepositInfo === void 0 ? void 0 : escrowDepositInfo.token.tokenAddress,
        abi: _chain_info_contracts_MockERC20_json__WEBPACK_IMPORTED_MODULE_7__/* .abi */ .Mt,
        functionName: "approve",
        chainId: escrowDepositInfo === null || escrowDepositInfo === void 0 ? void 0 : (ref2 = escrowDepositInfo.token) === null || ref2 === void 0 ? void 0 : ref2.chainId,
        args: [
            escrowDepositInfo === null || escrowDepositInfo === void 0 ? void 0 : escrowDepositInfo.escrowContractAddress,
            ethers__WEBPACK_IMPORTED_MODULE_11__.parseUnits(String((escrowDepositInfo === null || escrowDepositInfo === void 0 ? void 0 : (ref3 = escrowDepositInfo.tokenAmount) === null || ref3 === void 0 ? void 0 : ref3.toFixed(18)) || "0"), escrowDepositInfo === null || escrowDepositInfo === void 0 ? void 0 : escrowDepositInfo.token.decimal), 
        ]
    }), approveERC20 = ref8.writeAsync;
    var karatDeposit = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function() {
        var escrowDepositInfo, approveRes, approvetransReceipt, e, res, history, transReceipt, e1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    escrowDepositInfo = form === null || form === void 0 ? void 0 : form.karat;
                    console.log("start karat deposit", escrowDepositInfo);
                    _stores__WEBPACK_IMPORTED_MODULE_4__/* ["default"].dispatch */ .ZP.dispatch(_stores__WEBPACK_IMPORTED_MODULE_4__/* .actions.bridge.setDepositing */ .Nw.bridge.setDepositing(true));
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        ,
                        14,
                        15
                    ]);
                    if (!!isNativeToken(escrowDepositInfo === null || escrowDepositInfo === void 0 ? void 0 : escrowDepositInfo.token.tokenAddress)) return [
                        3,
                        7
                    ];
                    return [
                        4,
                        approveERC20()
                    ];
                case 2:
                    approveRes = _state.sent();
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        5,
                        ,
                        7
                    ]);
                    return [
                        4,
                        (0,wagmi_actions__WEBPACK_IMPORTED_MODULE_14__/* .waitForTransaction */ .Mn)({
                            hash: approveRes.hash
                        })
                    ];
                case 4:
                    approvetransReceipt = _state.sent();
                    if (approvetransReceipt.status === "reverted") {
                        throw new Error("Approve fail");
                    }
                    return [
                        3,
                        7
                    ];
                case 5:
                    e = _state.sent();
                    return [
                        4,
                        (0,_utils_validate__WEBPACK_IMPORTED_MODULE_9__/* .isSkipError */ .D0)(e)
                    ];
                case 6:
                    if (!_state.sent()) {
                        throw e;
                    }
                    return [
                        3,
                        7
                    ];
                case 7:
                    return [
                        4,
                        depositNativeToken()
                    ];
                case 8:
                    res = _state.sent();
                    history = {
                        transaction: res.hash,
                        type: "".concat(historyPrefix ? historyPrefix + "_" : "") + "karat",
                        chainId: escrowDepositInfo === null || escrowDepositInfo === void 0 ? void 0 : escrowDepositInfo.token.chainId,
                        value: parseFloat(String((escrowDepositInfo === null || escrowDepositInfo === void 0 ? void 0 : escrowDepositInfo.tokenAmount) || "0"))
                    };
                    _stores__WEBPACK_IMPORTED_MODULE_4__/* ["default"].dispatch */ .ZP.dispatch(_stores__WEBPACK_IMPORTED_MODULE_4__/* .actions.mint.setHistory */ .Nw.mint.setHistory({
                        history: history,
                        type: mintType
                    }));
                    _state.label = 9;
                case 9:
                    _state.trys.push([
                        9,
                        11,
                        ,
                        13
                    ]);
                    return [
                        4,
                        (0,wagmi_actions__WEBPACK_IMPORTED_MODULE_14__/* .waitForTransaction */ .Mn)({
                            hash: res.hash
                        })
                    ];
                case 10:
                    transReceipt = _state.sent();
                    if (transReceipt.status === "reverted") {
                        throw new Error("Deposit fail");
                    }
                    return [
                        3,
                        13
                    ];
                case 11:
                    e1 = _state.sent();
                    return [
                        4,
                        (0,_utils_validate__WEBPACK_IMPORTED_MODULE_9__/* .isSkipError */ .D0)(e1)
                    ];
                case 12:
                    if (!_state.sent()) {
                        throw e1;
                    }
                    return [
                        3,
                        13
                    ];
                case 13:
                    console.log("karat deposit success");
                    _stores__WEBPACK_IMPORTED_MODULE_4__/* ["default"].dispatch */ .ZP.dispatch(_stores__WEBPACK_IMPORTED_MODULE_4__/* .actions.bridge.setDepositSuccess */ .Nw.bridge.setDepositSuccess(true));
                    return [
                        2,
                        history
                    ];
                case 14:
                    _stores__WEBPACK_IMPORTED_MODULE_4__/* ["default"].dispatch */ .ZP.dispatch(_stores__WEBPACK_IMPORTED_MODULE_4__/* .actions.bridge.setDepositing */ .Nw.bridge.setDepositing(false));
                    return [
                        7
                    ];
                case 15:
                    return [
                        2
                    ];
            }
        });
    }), [
        depositNativeToken,
        approveERC20,
        form,
        mintType
    ]);
    var zkSyncDeposit = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function() {
        var depositInfo, chainId, zksyncProvider, walletClient, signer, depositHandle, history;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    depositInfo = form === null || form === void 0 ? void 0 : form.zksync;
                    if (!connector || !switchNetworkAsync) {
                        return [
                            2
                        ];
                    }
                    console.log("start zksync deposit", depositInfo);
                    chainId = parseInt(depositInfo.chain);
                    if (!((chain === null || chain === void 0 ? void 0 : chain.id) !== chainId)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        switchNetworkAsync(chainId)
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    mixpanel_browser__WEBPACK_IMPORTED_MODULE_8___default().track("zksync_deposit", {
                        scene: historyPrefix
                    });
                    zksyncProvider = new zksync_web3__WEBPACK_IMPORTED_MODULE_2__.Provider(chainId === 1 ? "https://mainnet.era.zksync.io" : "https://testnet.era.zksync.dev");
                    return [
                        4,
                        (0,wagmi_actions__WEBPACK_IMPORTED_MODULE_14__/* .getWalletClient */ .xz)({
                            chainId: chainId
                        })
                    ];
                case 3:
                    walletClient = _state.sent();
                    signer = zksync_web3__WEBPACK_IMPORTED_MODULE_2__.L1Signer.from((0,_services_ethers__WEBPACK_IMPORTED_MODULE_15__/* .walletClientToSigner */ .S)(walletClient), zksyncProvider);
                    _stores__WEBPACK_IMPORTED_MODULE_4__/* ["default"].dispatch */ .ZP.dispatch(_stores__WEBPACK_IMPORTED_MODULE_4__/* .actions.bridge.setDepositing */ .Nw.bridge.setDepositing(true));
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        ,
                        7,
                        8
                    ]);
                    return [
                        4,
                        signer.deposit({
                            token: zksync_web3__WEBPACK_IMPORTED_MODULE_2__.utils.ETH_ADDRESS,
                            amount: ethers__WEBPACK_IMPORTED_MODULE_11__.parseEther(String(depositInfo.depositCost))
                        })
                    ];
                case 5:
                    depositHandle = _state.sent();
                    history = {
                        transaction: depositHandle.hash,
                        type: "".concat(historyPrefix ? historyPrefix + "_" : "") + "zksync",
                        chainId: chainId,
                        value: depositInfo.depositCost
                    };
                    console.log("deposit history", history);
                    _stores__WEBPACK_IMPORTED_MODULE_4__/* ["default"].dispatch */ .ZP.dispatch(_stores__WEBPACK_IMPORTED_MODULE_4__/* .actions.mint.setHistory */ .Nw.mint.setHistory({
                        history: history,
                        type: mintType
                    }));
                    return [
                        4,
                        depositHandle.wait()
                    ];
                case 6:
                    _state.sent();
                    console.log("zksync deposit success");
                    _stores__WEBPACK_IMPORTED_MODULE_4__/* ["default"].dispatch */ .ZP.dispatch(_stores__WEBPACK_IMPORTED_MODULE_4__/* .actions.bridge.setDepositSuccess */ .Nw.bridge.setDepositSuccess(true));
                    return [
                        2,
                        history
                    ];
                case 7:
                    _stores__WEBPACK_IMPORTED_MODULE_4__/* ["default"].dispatch */ .ZP.dispatch(_stores__WEBPACK_IMPORTED_MODULE_4__/* .actions.bridge.setDepositing */ .Nw.bridge.setDepositing(false));
                    return [
                        7
                    ];
                case 8:
                    return [
                        2
                    ];
            }
        });
    }), [
        connector,
        switchNetworkAsync,
        form,
        chain,
        mintType,
        historyPrefix
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        console.log("historyStatus", historyStatus);
        if (historyStatus === "success") {
            _stores__WEBPACK_IMPORTED_MODULE_4__/* ["default"].dispatch */ .ZP.dispatch(_stores__WEBPACK_IMPORTED_MODULE_4__/* .actions.bridge.setDepositSuccess */ .Nw.bridge.setDepositSuccess(true));
            _stores__WEBPACK_IMPORTED_MODULE_4__/* ["default"].dispatch */ .ZP.dispatch(_stores__WEBPACK_IMPORTED_MODULE_4__/* .actions.bridge.setDepositing */ .Nw.bridge.setDepositing(false));
        } else if (historyStatus === "pending") {
            _stores__WEBPACK_IMPORTED_MODULE_4__/* ["default"].dispatch */ .ZP.dispatch(_stores__WEBPACK_IMPORTED_MODULE_4__/* .actions.bridge.setDepositing */ .Nw.bridge.setDepositing(true));
        } else {
            _stores__WEBPACK_IMPORTED_MODULE_4__/* ["default"].dispatch */ .ZP.dispatch(_stores__WEBPACK_IMPORTED_MODULE_4__/* .actions.bridge.setDepositSuccess */ .Nw.bridge.setDepositSuccess(false));
            _stores__WEBPACK_IMPORTED_MODULE_4__/* ["default"].dispatch */ .ZP.dispatch(_stores__WEBPACK_IMPORTED_MODULE_4__/* .actions.bridge.setDepositing */ .Nw.bridge.setDepositing(false));
        }
    }, [
        historyStatus
    ]);
    return {
        depositing: depositing,
        depositSuccess: depositSuccess,
        karatDeposit: karatDeposit,
        zkSyncDeposit: zkSyncDeposit,
        history: history
    };
}


/***/ }),

/***/ 56146:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMintHistory; }
/* harmony export */ });
/* harmony import */ var _stores__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27234);
/* harmony import */ var _hooks_useAccount__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98786);
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69077);
/* harmony import */ var _config_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35055);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useMintType__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70850);








var karatStatusMap = {
    success: "success",
    loading: "pending"
};
function useMintHistory() {
    var mintType = (0,_hooks_useMintType__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    var historyData = (0,_stores__WEBPACK_IMPORTED_MODULE_0__/* .useTypedSelector */ .ix)(function(state) {
        return state.mint;
    });
    var history = mintType === "validator" ? historyData.validatorHistory : historyData.claimerHistory;
    var address = (0,_hooks_useAccount__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().address;
    var ref = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useBalance */ .KQ)({
        address: (history === null || history === void 0 ? void 0 : history.type) === "zksync" ? address : undefined,
        chainId: _config_config__WEBPACK_IMPORTED_MODULE_2__/* .zksyncChainId */ .LK,
        watch: true
    }), zksyncBalance = ref.data;
    var ref1 = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useWaitForTransaction */ .BX)({
        hash: (history === null || history === void 0 ? void 0 : history.type) === "karat" ? history.transaction : undefined,
        chainId: history === null || history === void 0 ? void 0 : history.chainId
    }), karatTrans = ref1.data, error = ref1.error, karatTransStatus = ref1.status, isSuccess = ref1.isSuccess;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (karatTransStatus === "error") {
            _stores__WEBPACK_IMPORTED_MODULE_0__/* ["default"].dispatch */ .ZP.dispatch(_stores__WEBPACK_IMPORTED_MODULE_0__/* .actions.mint.setHistory */ .Nw.mint.setHistory({
                history: null,
                type: mintType
            }));
        }
    }, [
        karatTransStatus,
        mintType
    ]);
    var status = "idle";
    if ((history === null || history === void 0 ? void 0 : history.type) === "zksync") {
        status = parseFloat((zksyncBalance === null || zksyncBalance === void 0 ? void 0 : zksyncBalance.formatted) || "0") >= ((history === null || history === void 0 ? void 0 : history.value) || 0) ? "success" : "pending";
    } else if ((history === null || history === void 0 ? void 0 : history.type) === "karat") {
        status = karatStatusMap[karatTransStatus] || karatTransStatus;
    }
    return {
        history: history,
        status: status
    };
}


/***/ }),

/***/ 65581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMintReferral; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69077);
/* harmony import */ var _hooks_useAccount__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98786);
/* harmony import */ var _services_contract__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26720);






function useMintReferral(chainId) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var _query = router.query, validatorId = _query.validatorId, lieutenantAddress = _query.lieutenantAddress, ref = _query.ref;
    var isOKX = ref === "okx";
    var address = (0,_hooks_useAccount__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().address;
    var vid = parseInt(validatorId);
    if (isNaN(vid)) {
        vid = undefined;
    }
    var contract = _services_contract__WEBPACK_IMPORTED_MODULE_2__/* .validatorContracts */ .Fv[chainId];
    var data = (0,wagmi__WEBPACK_IMPORTED_MODULE_3__/* .useContractReads */ .Dm)({
        contracts: typeof vid !== "undefined" && lieutenantAddress ? [
            (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, contract), {
                functionName: "validatorMap",
                args: [
                    vid,
                    lieutenantAddress
                ]
            }), 
        ] : []
    }).data;
    return {
        hasParamLieutenant: typeof vid !== "undefined" && lieutenantAddress,
        isValidLieutenant: !!(data === null || data === void 0 ? void 0 : data[0]) && address !== lieutenantAddress,
        validatorId: isOKX ? "1" : typeof vid === "undefined" ? undefined : String(vid),
        lieutenantAddress: lieutenantAddress,
        ref: ref,
        isOKX: isOKX
    };
}


/***/ }),

/***/ 24455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMintResult; }
/* harmony export */ });
/* harmony import */ var _services_network_claimer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21373);
/* harmony import */ var _services_network_validator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33186);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _useMintType__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70850);
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69077);
/* harmony import */ var _config_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35055);







function useMintResult(mintId) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(undefined), txHash = ref[0], setTxHash = ref[1];
    var ref1 = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useTransaction */ .kF)({
        hash: txHash,
        chainId: _config_config__WEBPACK_IMPORTED_MODULE_4__/* .zksyncChainId */ .LK,
        cacheTime: 2000
    }), data = ref1.data, isLoading = ref1.isLoading, isSuccess = ref1.isSuccess, error = ref1.error;
    var timerRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var mintType = (0,_useMintType__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!mintId) {
            setTxHash(undefined);
            return;
        }
        timerRef.current = setInterval(function() {
            var func = mintType === "validator" ? _services_network_validator__WEBPACK_IMPORTED_MODULE_1__/* .getTxHashfromMintId */ .MQ : _services_network_claimer__WEBPACK_IMPORTED_MODULE_0__/* .getTxHashfromMintId */ .MQ;
            func({
                mintId: mintId
            }).then(function(data) {
                setTxHash(data.transactionHash);
                if (data.transactionHash) {
                    clearInterval(timerRef.current);
                }
            });
        }, 3000);
        return function() {
            timerRef.current && clearInterval(timerRef.current);
        };
    }, [
        mintId,
        mintType
    ]);
    return {
        data: data,
        error: error,
        isLoading: isLoading,
        isSuccess: isSuccess,
        mintId: mintId
    };
}


/***/ }),

/***/ 70850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMintType; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);

function useMintType() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    return router.pathname === "/mint/validator" || router.pathname === "/mint/recover/validator" ? "validator" : "claimer";
}


/***/ }),

/***/ 45576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useToggleStatus; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hooks-global-state/dist/index.modern.js + 2 modules
var index_modern = __webpack_require__(3558);
;// CONCATENATED MODULE: ./src/hooks/useGlobalState.ts

var initialState = {
    claimerMintToggleStatus: {
        wallet: false,
        accounts: false,
        validator: false,
        bridge: false,
        recover_tx: false
    }
};
var useGlobalState = (0,index_modern/* createGlobalState */.r)(initialState).useGlobalState;
/* harmony default export */ var hooks_useGlobalState = (useGlobalState);

;// CONCATENATED MODULE: ./src/hooks/useToggleStatus.ts




function useToggleStatus(key) {
    var ref = (0,_sliced_to_array/* default */.Z)(hooks_useGlobalState(key), 2), claimerMintToggleStatus = ref[0], setClaimerMintToggleStatus = ref[1];
    var toggle = (0,react.useCallback)(function(key) {
        var data = (0,_object_spread/* default */.Z)({}, claimerMintToggleStatus);
        if (data[key]) {
            data[key] = !data[key];
        } else {
            var keys = Object.keys(claimerMintToggleStatus);
            keys.forEach(function(key) {
                data[key] = false;
            });
            data[key] = true;
        }
        setClaimerMintToggleStatus(data);
    }, [
        claimerMintToggleStatus
    ]);
    var open = (0,react.useCallback)(function(key) {
        var keys = Object.keys(claimerMintToggleStatus);
        var data = (0,_object_spread/* default */.Z)({}, claimerMintToggleStatus);
        keys.forEach(function(key) {
            data[key] = false;
        });
        data[key] = true;
        setClaimerMintToggleStatus(data);
    }, [
        claimerMintToggleStatus
    ]);
    var close = (0,react.useCallback)(function(key) {
        var data = (0,_object_spread/* default */.Z)({}, claimerMintToggleStatus);
        data[key] = false;
        setClaimerMintToggleStatus(data);
    }, [
        claimerMintToggleStatus
    ]);
    var closeAll = (0,react.useCallback)(function() {
        var keys = Object.keys(claimerMintToggleStatus);
        var data = (0,_object_spread/* default */.Z)({}, claimerMintToggleStatus);
        keys.forEach(function(key) {
            data[key] = false;
        });
        setClaimerMintToggleStatus(data);
    }, [
        claimerMintToggleStatus
    ]);
    return {
        open: open,
        close: close,
        toggle: toggle,
        closeAll: closeAll,
        claimerMintToggleStatus: claimerMintToggleStatus
    };
}


/***/ }),

/***/ 21373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MQ": function() { return /* binding */ getTxHashfromMintId; },
/* harmony export */   "R8": function() { return /* binding */ mintByClaimer; },
/* harmony export */   "qE": function() { return /* binding */ requestMintClaimerSignature; }
/* harmony export */ });
/* unused harmony export getTxStatusfromMintId */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70655);
/* harmony import */ var _utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6293);



var requestMintClaimerSignature = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(data) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rpc */ .Z.rpc("claimer/requestMintClaimerSignature", data, {
                            endpoint: "network"
                        })
                    ];
                case 1:
                    // @ts-ignore
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function requestMintClaimerSignature(data) {
        return _ref.apply(this, arguments);
    };
}();
var getTxStatusfromMintId = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(data) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rpc */ .Z.rpc("claimer/getTxStatusfromMintId", data, {
                            endpoint: "network"
                        })
                    ];
                case 1:
                    // @ts-ignore
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getTxStatusfromMintId(data) {
        return _ref.apply(this, arguments);
    };
}();
var mintByClaimer = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(data) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rpc */ .Z.rpc("claimer/mintByClaimer", data, {
                            endpoint: "network"
                        })
                    ];
                case 1:
                    // @ts-ignore
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function mintByClaimer(data) {
        return _ref.apply(this, arguments);
    };
}();
var getTxHashfromMintId = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(data) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rpc */ .Z.rpc("claimer/getTxHashfromMintId", data, {
                            endpoint: "network"
                        })
                    ];
                case 1:
                    // @ts-ignore
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getTxHashfromMintId(data) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 33186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FA": function() { return /* binding */ getLieutenantFromGraph; },
/* harmony export */   "MQ": function() { return /* binding */ getTxHashfromMintId; },
/* harmony export */   "QS": function() { return /* binding */ getValidatorFromGraph; },
/* harmony export */   "fL": function() { return /* binding */ mintValidatorPublic; },
/* harmony export */   "k8": function() { return /* binding */ mintValidatorPrivate; }
/* harmony export */ });
/* unused harmony export getTxStatusfromMintId */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70655);
/* harmony import */ var _utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6293);



var mintValidatorPublic = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(data) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rpc */ .Z.rpc("validator/mintValidatorPublic", data, {
                            endpoint: "network"
                        })
                    ];
                case 1:
                    // @ts-ignore
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function mintValidatorPublic(data) {
        return _ref.apply(this, arguments);
    };
}();
var mintValidatorPrivate = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(data) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rpc */ .Z.rpc("validator/mintValidatorPrivate", data, {
                            endpoint: "network"
                        })
                    ];
                case 1:
                    // @ts-ignore
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function mintValidatorPrivate(data) {
        return _ref.apply(this, arguments);
    };
}();
var getTxStatusfromMintId = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(data) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rpc */ .Z.rpc("validator/getTxStatusfromMintId", data, {
                            endpoint: "network"
                        })
                    ];
                case 1:
                    // @ts-ignore
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getTxStatusfromMintId(data) {
        return _ref.apply(this, arguments);
    };
}();
var getTxHashfromMintId = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(data) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rpc */ .Z.rpc("validator/getTxHashfromMintId", data, {
                            endpoint: "network"
                        })
                    ];
                case 1:
                    // @ts-ignore
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getTxHashfromMintId(data) {
        return _ref.apply(this, arguments);
    };
}();
var getValidatorFromGraph = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(data) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rpc */ .Z.rpc("validator/getValidatorFromGraph", data, {
                            endpoint: "network"
                        })
                    ];
                case 1:
                    // @ts-ignore
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getValidatorFromGraph(data) {
        return _ref.apply(this, arguments);
    };
}();
var getLieutenantFromGraph = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(data) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rpc */ .Z.rpc("validator/getLieutenantFromGraph", data, {
                            endpoint: "network"
                        })
                    ];
                case 1:
                    // @ts-ignore
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getLieutenantFromGraph(data) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 26837:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 3558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* binding */ n; }
});

// UNUSED EXPORTS: createStore

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-hooks-global-state/node_modules/zustand/esm/vanilla.js
const createStoreImpl = (createState) => {
  let state;
  const listeners = /* @__PURE__ */ new Set();
  const setState = (partial, replace) => {
    const nextState = typeof partial === "function" ? partial(state) : partial;
    if (nextState !== state) {
      const previousState = state;
      state = replace ? nextState : Object.assign({}, state, nextState);
      listeners.forEach((listener) => listener(state, previousState));
    }
  };
  const getState = () => state;
  const subscribe = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  };
  const destroy = () => listeners.clear();
  const api = { setState, getState, subscribe, destroy };
  state = createState(
    setState,
    getState,
    api
  );
  return api;
};
const createStore = (createState) => createState ? createStoreImpl(createState) : createStoreImpl;



// EXTERNAL MODULE: ./node_modules/use-sync-external-store/shim/with-selector.js
var with_selector = __webpack_require__(52798);
;// CONCATENATED MODULE: ./node_modules/react-hooks-global-state/node_modules/zustand/esm/index.js






const { useSyncExternalStoreWithSelector } = with_selector;
function useStore(api, selector = api.getState, equalityFn) {
  const slice = useSyncExternalStoreWithSelector(
    api.subscribe,
    api.getState,
    api.getServerState || api.getState,
    selector,
    equalityFn
  );
  (0,react.useDebugValue)(slice);
  return slice;
}
const createImpl = (createState) => {
  const api = typeof createState === "function" ? createStore(createState) : createState;
  const useBoundStore = (selector, equalityFn) => useStore(api, selector, equalityFn);
  Object.assign(useBoundStore, api);
  return useBoundStore;
};
const create = (createState) => createState ? createImpl(createState) : createImpl;
var create$1 = create;



;// CONCATENATED MODULE: ./node_modules/react-hooks-global-state/dist/index.modern.js
const o=(t,e)=>{if(!t.includes(e))throw new Error(`'${e}' not found. It must be provided in initialState as a property key.`)},n=r=>{const n=create$1(()=>r),s=Object.keys(r),a=(t,e)=>{ false&&0,n.setState(r=>{return{[t]:(o=r[t],n=e,"function"==typeof n?n(o):n)};var o,n})};return{useGlobalState:e=>{ false&&0;const r=(0,react.useCallback)(t=>t[e],[e]);return[n(r),(0,react.useCallback)(t=>a(e,t),[e])]},getGlobalState:t=>( false&&0,n.getState()[t]),setGlobalState:a,subscribe:(t,e)=>{n.subscribe((r,o)=>{r[t]!==o[t]&&e(r[t])})}}},s=(o,n=o(void 0,{type:void 0}),a)=>{if(a)return a(s)(o,n);const i=e(r(o,n)),u=Object.keys(n),c=e=>{ false&&0;const r=t(t=>t[e],[e]);return i(r)};return{useStoreState:c,useGlobalState:e=>( false&&0,[c(e),t(t=>{i.setState(r=>{return{[e]:(o=r[e],n=t,"function"==typeof n?n(o):n)};var o,n})},[e])]),getState:i.getState,dispatch:i.dispatch}};
//# sourceMappingURL=index.modern.js.map


/***/ }),

/***/ 24881:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"v":"5.7.4","fr":25,"ip":0,"op":44,"w":1080,"h":1080,"nm":"Gift Box","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":3,"nm":"Null 1","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[-3]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":11.812,"s":[3]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":16.875,"s":[-3]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":20.25,"s":[3]},{"t":27,"s":[0]}],"ix":10},"p":{"a":0,"k":[540,838,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"ip":0,"op":2000,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Bow ","parent":3,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[315.78,-1.75,0],"ix":2,"l":2},"a":{"a":0,"k":[181.856,233.58,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[21.6,0],[0,-13.229],[0,0]],"o":[[-21.6,0],[0,0],[0,-13.229]],"v":[[0,-11.977],[-39.111,11.977],[39.111,11.977]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.966000007181,0.910000011968,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[164.425,224.936],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-12.449,11.376],[-40.737,6.857],[-6.418,-1.98],[22.036,-18.753],[51.466,7.407],[-4.164,3.412]],"o":[[29.603,-26.825],[6.934,-1.031],[1.247,24.047],[-39.124,32.851],[4.456,-6.464],[12.897,-10.552]],"v":[[-36.707,5.374],[68.751,-59.658],[89.566,-58.683],[55.617,8.096],[-90.814,53.282],[-74.74,37.22]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.898000021542,0.866999966491,0.827000038297,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-12.487,18.263],[-19.706,21.572],[-37.656,-37.057],[-0.809,-15.65],[6.934,-1.03],[29.603,-26.825],[12.897,-10.552],[4.456,-6.464],[6.943,2.123]],"o":[[6.562,-21.454],[15.681,-24.186],[28.047,-30.759],[14.67,14.289],[-6.418,-1.98],[-40.737,6.857],[-12.449,11.376],[-4.164,3.412],[-7.171,-1.031],[0,0]],"v":[[-102.177,90.39],[-71.273,32.214],[-21.906,-38.946],[79.842,-60.261],[102.177,-14.647],[81.362,-15.622],[-24.096,49.41],[-62.129,81.256],[-78.203,97.318],[-99.41,92.617]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.966000007181,0.910000011968,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-12.97,-44.371],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":2,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"tr","p":{"a":0,"k":[155.453,229.933],"ix":2},"a":{"a":0,"k":[-113.922,55.199],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":3,"s":[31]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":16,"s":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":21.5,"s":[7]},{"t":27,"s":[-2]}],"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":3,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[8.577,14.521],[36.948,18.48],[6.718,-0.016],[-15.588,-24.382],[-51.382,-7.98],[2.99,4.489]],"o":[[-20.454,-34.315],[-6.325,-3.005],[-8.225,22.629],[27.794,42.861],[-2.372,-7.49],[-9.238,-13.862]],"v":[[36.251,18.289],[-45.564,-74.764],[-65.753,-79.918],[-52.822,-6.129],[73.977,79.934],[63.302,59.867]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.898000021542,0.866999966491,0.827000038297,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[6.598,21.118],[12.536,26.393],[46.845,-24.424],[5.352,-14.727],[-6.325,-3.005],[-20.454,-34.315],[-9.237,-13.861],[-2.371,-7.49],[-7.263,0]],"o":[[0,-22.433],[-7.918,-27.717],[-17.815,-37.618],[-18.212,9.365],[6.719,-0.015],[36.949,18.479],[8.577,14.521],[2.99,4.49],[7.16,1.114],[0,0]],"v":[[82.342,110.213],[69.806,45.537],[43.414,-36.954],[-47.638,-87.108],[-82.342,-50.031],[-62.154,-44.876],[19.661,48.176],[46.713,89.754],[57.388,109.821],[79.043,111.532]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.966000007181,0.910000011968,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[16.875,-29.768],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 5","np":2,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"tr","p":{"a":0,"k":[168.665,225.792],"ix":2},"a":{"a":0,"k":[94.438,84.122],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":3,"s":[-29]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":9,"s":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":14,"s":[-8]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":19,"s":[1]},{"t":24,"s":[-10]}],"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":3,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":2000,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Box top ","parent":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0.333,"y":0},"t":0,"s":[-6.373,-996.35,0],"to":[-0.333,92,0],"ti":[0.333,-92,0]},{"t":6,"s":[-8.373,-444.35,0]}],"ix":2,"l":2},"a":{"a":0,"k":[302.088,0.25,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":0,"s":[100,148.389,100]},{"t":15,"s":[100,100,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[10.837,0],[0,0],[0,-10.832],[0,0],[10.833,0],[0,0],[0,10.837],[0,0]],"o":[[0,0],[10.833,0],[0,0],[0,10.837],[0,0],[10.837,0],[0,0],[0,-10.832]],"v":[[17.16,-43.398],[-36.855,-43.398],[-17.158,-23.702],[-17.158,23.701],[-36.855,43.398],[17.16,43.398],[36.855,23.701],[36.855,-23.702]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.898000021542,0.866999966491,0.827000038297,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[447.248,43.648],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-10.833,0],[0,0],[0,-10.832],[0,0],[-10.833,0],[0,0],[0,10.837],[0,0]],"o":[[0,0],[-10.833,0],[0,0],[0,10.837],[0,0],[-10.833,0],[0,0],[0,-10.832]],"v":[[-17.161,-43.398],[36.854,-43.398],[17.161,-23.702],[17.161,23.701],[36.854,43.398],[-17.161,43.398],[-36.854,23.701],[-36.854,-23.702]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.966000007181,0.910000011968,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[156.924,43.648],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-10.833,0],[0,0],[0,-10.832],[0,0],[10.837,0],[0,0],[0,10.837],[0,0]],"o":[[0,0],[10.837,0],[0,0],[0,10.837],[0,0],[-10.833,0],[0,0],[0,-10.832]],"v":[[-141.069,-43.398],[141.069,-43.398],[160.766,-23.702],[160.766,23.701],[141.069,43.398],[-141.069,43.398],[-160.766,23.701],[-160.766,-23.702]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.501999978458,0.694000004787,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[443.157,43.648],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":2,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-10.833,0],[0,0],[0,-10.835],[0,0],[10.828,0],[0,0],[0,10.837],[0,0]],"o":[[0,0],[10.828,0],[0,0],[0,10.837],[0,0],[-10.833,0],[0,0],[0,-10.835]],"v":[[-282.145,-43.398],[282.146,-43.398],[301.838,-23.702],[301.838,23.701],[282.146,43.398],[-282.145,43.398],[-301.838,23.701],[-301.838,-23.702]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.62400004069,0.74900004069,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[302.088,43.648],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":4,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":2000,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"Box down ","parent":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":0,"s":[-8.373,396.905,0],"to":[0,-70.333,0],"ti":[0,70.333,0]},{"t":6,"s":[-8.373,-25.095,0]}],"ix":2,"l":2},"a":{"a":0,"k":[270.88,338.17,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0,0,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":0,"s":[100,31.937,100]},{"t":12,"s":[100,100,100]}],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[-27.008,15.111],[27.008,15.111],[27.008,-15.111],[-27.008,-15.111]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.702000038297,0.795999983245,0.917999985639,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[406.197,15.361],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[14.067,0],[0,0],[0,14.067]],"o":[[0,0],[0,0],[0,14.067],[0,0],[14.066,0],[0,0]],"v":[[39.794,-168.229],[-14.221,-168.229],[-14.221,142.652],[-39.794,168.229],[14.221,168.229],[39.794,142.652]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.898000021542,0.866999966491,0.827000038297,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[393.406,169.941],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[-27.007,15.111],[27.007,15.111],[27.007,-15.111],[-27.007,-15.111]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.830999995213,0.885999971278,0.964999988032,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[135.564,15.361],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":2,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[-14.062,0],[0,0],[0,14.067]],"o":[[0,0],[0,0],[0,14.067],[0,0],[-14.067,0],[0,0]],"v":[[-39.794,-168.229],[14.221,-168.229],[14.221,142.652],[39.794,168.229],[-14.22,168.229],[-39.794,142.652]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.966000007181,0.910000011968,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[148.35,169.941],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":4,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[135.314,15.111],[-135.314,15.111],[-135.314,-15.111],[135.314,-15.111]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.39199999641,0.638999968884,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[406.197,15.377],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 5","np":2,"cix":2,"bm":0,"ix":5,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[-135.314,15.111],[135.314,15.111],[135.314,-15.111],[-135.314,-15.111]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.39199999641,0.638999968884,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[135.564,15.377],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 6","np":2,"cix":2,"bm":0,"ix":6,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,-0.008],[0,0],[14.068,0],[0,0],[0,14.067]],"o":[[0,0],[0.007,0],[0,0],[0,14.067],[0,0],[-14.068,0],[0,0]],"v":[[-135.314,-168.229],[135.299,-168.229],[135.314,-168.213],[135.314,142.652],[109.74,168.229],[-109.74,168.229],[-135.314,142.652]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.501999978458,0.694000004787,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[406.195,168.496],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 7","np":2,"cix":2,"bm":0,"ix":7,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,-0.008],[0,0],[14.067,0],[0,0],[0,14.067]],"o":[[0,0],[0.008,0],[0,0],[0,14.067],[0,0],[-14.067,0],[0,0]],"v":[[-270.629,-168.229],[270.613,-168.229],[270.629,-168.217],[270.629,142.652],[245.055,168.229],[-245.056,168.229],[-270.629,142.652]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.62400004069,0.74900004069,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[270.881,168.496],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 8","np":2,"cix":2,"bm":0,"ix":8,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":2000,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Shapes","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[531.703,557.169,0],"ix":2,"l":2},"a":{"a":0,"k":[433.93,240.349,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-3.992,0],[0,3.994],[3.991,0],[0,-3.993]],"o":[[3.991,0],[0,-3.993],[-3.992,0],[0,3.994]],"v":[[0.001,7.251],[7.253,-0.001],[0.001,-7.251],[-7.253,-0.001]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.62400004069,0.74900004069,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0.333,"y":0},"t":4,"s":[441.332,416.977],"to":[61.076,8.566],"ti":[-74.409,-18.566]},{"i":{"x":0,"y":1},"o":{"x":0.167,"y":0},"t":14,"s":[807.785,468.376],"to":[74.409,18.566],"ti":[0,0]},{"i":{"x":0,"y":1},"o":{"x":0.167,"y":0},"t":27,"s":[887.785,528.376],"to":[0,0],"ti":[13.333,10]},{"t":35,"s":[807.785,468.376]}],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-3.991,0],[0,3.995],[3.992,0],[0,-3.992]],"o":[[3.992,0],[0,-3.992],[-3.991,0],[0,3.995]],"v":[[0,7.251],[7.253,-0.001],[0,-7.251],[-7.253,-0.001]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.62400004069,0.74900004069,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0.333,"y":0},"t":4,"s":[440.357,419.957],"to":[70,-30],"ti":[-80,36.667]},{"i":{"x":0,"y":1},"o":{"x":0.167,"y":0},"t":10,"s":[860.357,239.957],"to":[80,-36.667],"ti":[0,0]},{"i":{"x":0,"y":1},"o":{"x":0.167,"y":0},"t":19,"s":[920.357,199.957],"to":[0,0],"ti":[10,-6.667]},{"t":32,"s":[860.357,239.957]}],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-3.991,0],[0,3.996],[3.992,0],[0,-3.993]],"o":[[3.992,0],[0,-3.993],[-3.991,0],[0,3.996]],"v":[[0.002,7.25],[7.255,-0.005],[0.002,-7.25],[-7.255,-0.005]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.62400004069,0.74900004069,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0.333,"y":0},"t":4,"s":[442.818,421.052],"to":[46.611,-63.201],"ti":[-59.945,83.201]},{"i":{"x":0,"y":1},"o":{"x":0.167,"y":0},"t":14,"s":[722.486,41.849],"to":[59.945,-83.201],"ti":[0,0]},{"i":{"x":0,"y":1},"o":{"x":0.167,"y":0},"t":24,"s":[802.486,-78.151],"to":[0,0],"ti":[13.333,-20]},{"t":40,"s":[722.486,41.849]}],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":2,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-3.992,0],[0,3.996],[3.993,0],[0,-3.996]],"o":[[3.993,0],[0,-3.996],[-3.992,0],[0,3.996]],"v":[[-0.002,7.251],[7.251,-0.002],[-0.002,-7.251],[-7.251,-0.002]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.62400004069,0.74900004069,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0.333,"y":0},"t":4,"s":[444.882,424.091],"to":[-45.734,-69.432],"ti":[52.401,89.432]},{"i":{"x":0,"y":1},"o":{"x":0.167,"y":0},"t":9,"s":[170.476,7.501],"to":[-52.401,-89.432],"ti":[0,0]},{"i":{"x":0,"y":1},"o":{"x":0.167,"y":0},"t":19,"s":[130.476,-112.499],"to":[0,0],"ti":[-6.667,-20]},{"t":30,"s":[170.476,7.501]}],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":4,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-3.993,0],[0,3.996],[3.992,0],[0,-3.991]],"o":[[3.992,0],[0,-3.991],[-3.993,0],[0,3.996]],"v":[[0.001,7.253],[7.253,-0.004],[0.001,-7.253],[-7.253,-0.004]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.62400004069,0.74900004069,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0.333,"y":0},"t":4,"s":[443.725,419.761],"to":[-69.078,8.906],"ti":[75.745,-28.906]},{"i":{"x":0,"y":1},"o":{"x":0.167,"y":0},"t":15,"s":[29.256,473.194],"to":[-75.745,28.906],"ti":[0,0]},{"i":{"x":0,"y":1},"o":{"x":0.167,"y":0},"t":28,"s":[-10.744,593.194],"to":[0,0],"ti":[-6.667,20]},{"t":41,"s":[29.256,473.194]}],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 5","np":2,"cix":2,"bm":0,"ix":5,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-3.993,0],[0,3.995],[3.991,0],[0,-3.992]],"o":[[3.991,0],[0,-3.992],[-3.993,0],[0,3.995]],"v":[[0.001,7.251],[7.253,-0.002],[0.001,-7.251],[-7.253,-0.002]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.62400004069,0.74900004069,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0.333,"y":0},"t":4,"s":[445.417,421.734],"to":[-72.986,-31.004],"ti":[86.319,31.004]},{"i":{"x":0,"y":1},"o":{"x":0.167,"y":0},"t":10,"s":[7.503,235.711],"to":[-86.319,-31.004],"ti":[0,0]},{"i":{"x":0,"y":1},"o":{"x":0.167,"y":0},"t":18,"s":[-72.497,235.711],"to":[0,0],"ti":[-13.333,0]},{"t":35,"s":[7.503,235.711]}],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 6","np":2,"cix":2,"bm":0,"ix":6,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[4.146,1.739],[4.516,-1.844],[0,0],[1.739,-4.146],[-1.843,-4.516],[0,0],[-4.152,-1.739],[-4.516,1.844],[0,0],[-1.743,4.153],[1.845,4.517]],"o":[[-1.859,-4.431],[-4.197,-1.762],[0,0],[-4.431,1.854],[-1.762,4.194],[0,0],[1.859,4.438],[4.195,1.762],[0,0],[4.435,-1.855],[1.765,-4.199],[0,0]],"v":[[16.351,-6.863],[6.86,-16.327],[-6.708,-16.414],[-6.862,-16.349],[-16.326,-6.859],[-16.413,6.709],[-16.356,6.851],[-6.859,16.326],[6.71,16.413],[6.852,16.353],[16.324,6.859],[16.413,-6.71]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[-2.883,-7.065],[0,0],[0,0],[2.593,-6.181],[7.064,-2.887],[0,0],[0,0],[6.18,2.598],[2.89,7.067],[0,0],[0,0],[-2.598,6.184],[-7.061,2.886],[0,0],[0,0],[-6.181,-2.6]],"o":[[0,0],[0,0],[2.467,6.77],[-2.725,6.488],[0,0],[0,0],[-6.766,2.467],[-6.489,-2.721],[0,0],[0,0],[-2.469,-6.769],[2.722,-6.489],[0,0],[0,0],[6.77,-2.467],[6.491,2.718]],"v":[[25.511,-10.413],[25.901,-9.468],[25.901,-9.416],[25.429,10.678],[10.414,25.514],[9.469,25.899],[9.413,25.899],[-10.677,25.427],[-25.517,10.411],[-25.899,9.468],[-25.899,9.415],[-25.427,-10.678],[-10.416,-25.514],[-9.471,-25.899],[-9.415,-25.899],[10.676,-25.425]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"fl","c":{"a":0,"k":[0.62400004069,0.74900004069,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0.333,"y":0},"t":4,"s":[443.396,420.957],"to":[-61.083,-9.702],"ti":[74.417,-3.632]},{"i":{"x":0,"y":1},"o":{"x":0.167,"y":0},"t":13,"s":[76.896,362.746],"to":[-74.417,3.632],"ti":[0,0]},{"i":{"x":0,"y":1},"o":{"x":0.167,"y":0},"t":27,"s":[-3.104,442.746],"to":[0,0],"ti":[-13.333,13.333]},{"t":41,"s":[76.896,362.746]}],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 7","np":4,"cix":2,"bm":0,"ix":7,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,-2.878],[2.882,0],[0,0],[0,2.878],[-2.879,0]],"o":[[2.882,0],[0,2.878],[0,0],[-2.879,0],[0,-2.878],[0,0]],"v":[[20.076,-5.214],[25.293,0],[20.076,5.214],[-20.079,5.214],[-25.293,0],[-20.079,-5.214]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[2.881,0],[0,2.883],[0,0],[-2.88,0],[0,-2.879]],"o":[[0,2.883],[-2.88,0],[0,0],[0,-2.879],[2.881,0],[0,0]],"v":[[5.214,20.076],[-0.002,25.294],[-5.217,20.076],[-5.217,-20.078],[-0.002,-25.292],[5.214,-20.078]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.62400004069,0.74900004069,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0.333,"y":0},"t":4,"s":[443.149,420.228],"to":[-63.527,-60.986],"ti":[70.193,74.319]},{"i":{"x":0,"y":1},"o":{"x":0.167,"y":0},"t":10,"s":[61.989,54.314],"to":[-70.193,-74.319],"ti":[0,0]},{"i":{"x":0,"y":1},"o":{"x":0.167,"y":0},"t":21,"s":[21.989,-25.686],"to":[0,0],"ti":[-6.667,-13.333]},{"t":34,"s":[61.989,54.314]}],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 8","np":3,"cix":2,"bm":0,"ix":8,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,-2.883],[2.884,0],[0,0],[0,2.875],[-2.879,0]],"o":[[2.884,0],[0,2.875],[0,0],[-2.879,0],[0,-2.883],[0,0]],"v":[[20.074,-5.214],[25.293,0.004],[20.074,5.214],[-20.079,5.214],[-25.293,0.004],[-20.079,-5.214]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[2.882,0],[0,2.883],[0,0],[-2.878,0],[0,-2.883]],"o":[[0,2.883],[-2.878,0],[0,0],[0,-2.883],[2.882,0],[0,0]],"v":[[5.214,20.079],[-0.004,25.297],[-5.218,20.079],[-5.218,-20.074],[-0.004,-25.293],[5.214,-20.074]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.62400004069,0.74900004069,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0.333,"y":0},"t":4,"s":[446.037,421.125],"to":[57.443,-12.935],"ti":[-70.776,6.268]},{"i":{"x":0,"y":1},"o":{"x":0.167,"y":0},"t":15,"s":[790.694,343.516],"to":[70.776,-6.268],"ti":[0,0]},{"i":{"x":0,"y":1},"o":{"x":0.167,"y":0},"t":19,"s":[870.694,383.516],"to":[0,0],"ti":[13.333,6.667]},{"t":40,"s":[790.694,343.516]}],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 10","np":3,"cix":2,"bm":0,"ix":9,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[4.145,1.739],[4.513,-1.84],[0,0],[1.743,-4.141],[-1.844,-4.516],[0,0],[-4.153,-1.738],[-4.516,1.841],[0,0],[-1.744,4.153],[1.845,4.513]],"o":[[-1.858,-4.43],[-4.198,-1.762],[0,0],[-4.43,1.855],[-1.758,4.198],[0,0],[1.855,4.438],[4.194,1.763],[0,0],[4.439,-1.851],[1.765,-4.198],[0,0]],"v":[[16.351,-6.865],[6.861,-16.325],[-6.708,-16.415],[-6.862,-16.347],[-16.329,-6.861],[-16.412,6.711],[-16.355,6.85],[-6.857,16.324],[6.711,16.415],[6.849,16.351],[16.325,6.861],[16.414,-6.707]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[-2.882,-7.069],[0,0],[0,0],[2.598,-6.184],[7.065,-2.89],[0,0],[0,0],[6.18,2.602],[2.887,7.069],[0,0],[0,0],[-2.598,6.185],[-7.062,2.886],[0,0],[0,0],[-6.179,-2.601]],"o":[[0,0],[0,0],[2.47,6.765],[-2.72,6.484],[0,0],[0,0],[-6.761,2.465],[-6.49,-2.721],[0,0],[0,0],[-2.47,-6.765],[2.72,-6.487],[0,0],[0,0],[6.766,-2.466],[6.492,2.722]],"v":[[25.511,-10.41],[25.898,-9.466],[25.898,-9.413],[25.425,10.681],[10.414,25.516],[9.469,25.899],[9.41,25.899],[-10.676,25.426],[-25.516,10.411],[-25.898,9.466],[-25.898,9.414],[-25.425,-10.681],[-10.414,-25.515],[-9.47,-25.898],[-9.414,-25.898],[10.676,-25.426]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"fl","c":{"a":0,"k":[0.62400004069,0.74900004069,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0.333,"y":0},"t":4,"s":[445.089,419.125],"to":[58.173,-54.073],"ti":[-71.507,60.74]},{"i":{"x":0,"y":1},"o":{"x":0.333,"y":0},"t":11,"s":[794.128,94.687],"to":[71.507,-60.74],"ti":[0,0]},{"i":{"x":0,"y":1},"o":{"x":0.167,"y":0},"t":26,"s":[874.128,54.687],"to":[0,0],"ti":[13.333,-6.667]},{"t":37,"s":[794.128,94.687]}],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 12","np":4,"cix":2,"bm":0,"ix":10,"mn":"ADBE Vector Group","hd":false}],"ip":4,"op":2004,"st":4,"bm":0}],"markers":[]}');

/***/ })

}]);